export default __webpack_public_path__ + "static/hi-397f250ffa25d01996273cc479afde72.webp";